// Add authentication token to every request
const isDev = import.meta.env.DEV;
const defaultCountry = isDev
  ? import.meta.env.VITE_COUNTRIES?.split(',')[0]?.trim() || 'MX'
  : sessionStorage.getItem('countryCode') || 'MX';

export const authInterceptor = (config) => {
  const token = localStorage.getItem('msalAccessToken') || 'not_required';
  const country = isDev
    ? defaultCountry
    : sessionStorage.getItem('countryCode') || 'MX';
  config.headers.countryCode = country;
  config.headers['Time-Zone'] =
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  config.headers.country = country;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(authInterceptor, (error) =>
    Promise.reject(new Error(error))
  );
};
